export enum SupabaseMigrationResource {
    User = 'user',
    Database = 'database',
    Table = 'table',
    Column = 'column',
    Index = 'index',
    Row = 'row',
    Document = 'document',
    Attribute = 'attribute',
    Collection = 'collection',
    Bucket = 'bucket',
    File = 'file',
}
